import { Store } from "pullstate";

export const TownStore = new Store({
  townDoc: null,
  announcements: null,
  riskLevel: null,
  burnBan: null,
});